/** @file Items of a socket: attachments mounted on it, and attachments that could be equipped on it. */
import { entriesByName } from '@pose2d/format/doc/entriesByName';
import type { Doc, Id } from '@pose2d/format/types';
import type { SelectOption } from '../../ui-kit/Select';

/** Mounted items (by name) and Select options of the equippable ones: a handle, and a region or rigid mesh (§5.9). */
export interface SocketItemRows {
  mounted: { id: Id; name: string; fitLength: boolean }[];
  equippable: SelectOption[];
}

/** Items mounted on another socket are equippable here (socket.equip moves them). */
export function itemsOfSocket(doc: Doc, socket: Id): SocketItemRows {
  const rows: SocketItemRows = { mounted: [], equippable: [] };
  for (const [id, att] of entriesByName(doc.attachments)) {
    if (att.mount?.socket === socket) rows.mounted.push({ id, name: att.name, fitLength: att.mount.fitLength });
    else if (att.handle !== undefined && (att.type === 'region' || att.geometry.kind === 'rigid')) rows.equippable.push({ value: id, label: att.name });
  }
  return rows;
}
